import faqListReducer from './faqList'

export default faqListReducer;
